import React, { memo } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  IconButton,
  Icon,
} from "investira.react.components";
import { validators, formats } from "investira.sdk";
import ConcentracaoGraph from "./ConcentracaoGraph";
import { useConsultaContext } from "../../../../../contexts/ConsultaContext";

const ConcentracaoTable = memo((props) => {
  const { detalhe, variant, onSetRegra } = props;

  const { state } = useConsultaContext();

  function calcRangeEnquadramento(pMin = 0, pMax = 50) {
    return Math.abs(pMax - pMin);
  }

  function calcAlvoRange(
    pAlvo = null,
    pAlvoLimites = {},
    pDesenquadradoAlvo = null,
    pDesenquadrado = null
  ) {
    let targetColors = "white";

    if (!validators.isNull(pDesenquadrado)) {
      targetColors = "error.light";
    }

    if (!validators.isNull(pDesenquadradoAlvo)) {
      targetColors = "warning.light";
    }

    return {
      alvo: pAlvo,
      alvoLimites: pAlvoLimites,
      alvoWidth: pAlvoLimites?.maximo - pAlvoLimites.minimo,
      desenquadradoAlvo: !validators.isNull(pDesenquadradoAlvo),
      pDesenquadrado: !validators.isNull(pDesenquadrado),
      noAlvo: !validators.isNull(pDesenquadradoAlvo),
      targetColor: targetColors,
    };
  }

  function calcObservado(pObservado) {
    if (pObservado <= 0) {
      return "0%";
    }

    return `calc(${pObservado}% - 1px)`;
  }

  const detalheFiltrado = state.exibir_desenquadrado
    ? detalhe.filter((x) => x.desenquadrado)
    : detalhe;

  return (
    <TableContainer
      id="table-container"
      sx={{
        overflow: "auto",
      }}
    >
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Descrição</TableCell>
            <TableCell></TableCell>
            <TableCell align="right">Mínimo (%)</TableCell>
            <TableCell align="right">Máximo (%)</TableCell>
            <TableCell align="right">Observado</TableCell>
            <TableCell align="right">Observado (%)</TableCell>
            <TableCell align="right">Alvo (%)</TableCell>
            <TableCell align="right">Desenquadrado</TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="center"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {detalheFiltrado.map((xDetalhe) => {
            const hasDesenquadrado =
              !validators.isNull(xDetalhe.desenquadrado) ||
              !validators.isNull(xDetalhe.desenquadrado_alvo);

            const xEnquadramentoRange = calcRangeEnquadramento(
              xDetalhe.minimo,
              xDetalhe.maximo
            );
            const xAlvo = calcAlvoRange(
              xDetalhe.alvo,
              xDetalhe.alvo_limites,
              xDetalhe.desenquadrado_alvo,
              xDetalhe.desenquadrado
            );
            const xObservado = calcObservado(xDetalhe.observado);
            const isEnquadrado = validators.isNull(xDetalhe.desenquadrado);

            return (
              <React.Fragment key={crypto.randomUUID()}>
                <TableRow>
                  <TableCell
                    colSpan={2}
                    sx={{
                      color: xAlvo.targetColor,
                    }}
                  >
                    {xDetalhe.descricao}
                  </TableCell>
                  <TableCell align="right" sx={{ color: "text.secondary" }}>
                    {xDetalhe.minimo}
                  </TableCell>
                  <TableCell align="right" sx={{ color: "text.secondary" }}>
                    {xDetalhe.maximo}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      color: xAlvo.targetColor,
                    }}
                  >
                    {formats.formatNumber(xDetalhe.financeiro, 2, true)}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      color: xAlvo.targetColor,
                    }}
                  >
                    {xDetalhe.observado &&
                      formats.formatNumber(xDetalhe.observado, 2, true)}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{ color: "info.main", fontWeight: 600 }}
                  >
                    {xDetalhe.alvo}
                  </TableCell>
                  <TableCell
                    align={hasDesenquadrado ? "right" : "center"}
                    sx={{
                      color: xAlvo.targetColor,
                    }}
                  >
                    {hasDesenquadrado
                      ? formats.formatNumber(
                          xDetalhe.desenquadrado || xDetalhe.desenquadrado_alvo,
                          2,
                          true
                        )
                      : ""}
                  </TableCell>
                  <TableCell align="center">
                    <ConcentracaoGraph
                      range={xEnquadramentoRange}
                      minimo={xDetalhe.minimo}
                      alvo={xAlvo}
                      observado={xObservado}
                      targetColor={xAlvo.targetColor}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      color="primary"
                      size="small"
                      onClick={() =>
                        onSetRegra({
                          ...xDetalhe,
                          grafico: {
                            range: xEnquadramentoRange,
                            minimo: xDetalhe.minimo,
                            alvo: xAlvo,
                            observado: xObservado,
                            enquadrado: isEnquadrado,
                          },
                        })
                      }
                    >
                      <Icon iconName="eye" size={21} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
});

ConcentracaoTable.displayName = "ConcentracaoTable";

export default ConcentracaoTable;
